
 
    import { Options, Vue  } from "vue-class-component"; 
    
    @Options({
        name: "Equipe",
        components: { },  
    }) 
    export default class Equipe extends Vue {
  
    } 

